module.exports = __webpack_public_path__ + "static/media/insurance.dc85b4d5.svg";